import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class StartGameAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        this.emitter.emit('General.Game.STARTED');
        this.eventManager.emit('General.Game.STARTED');
        this.eventManager.emit('General.Game.FIRST_INTERACTION');
    }

    getName(): string {
        return 'StartGameAct';
    }
}